import {
    Box,
    Button,
    Divider,
    Drawer,
    IconButton,
    Tooltip,
    Typography,
} from "@material-ui/core";

import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";

export function QuestionDetailDrawer({ open, question, selectedIds, onClose, onAdd, onRemove }) {
    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <Box width={520} p={2}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography variant="h6">Detalhes da questão</Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Divider style={{ margin: "12px 0" }} />

                {!question ? (
                    <Typography variant="body2" color="textSecondary">
                        Selecione uma questão para ver os detalhes.
                    </Typography>
                ) : (
                    <>
                        <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
                            {question.name}
                        </Typography>

                        <Box
                            mt={0.5}
                            mb={1}
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            <Typography variant="caption" color="textSecondary">
                                Área do direito: {question.theme?.name || "-"} •{" "}
                                {question.ownerId == null ? "Pré-cadastrada" : "Minha"}
                            </Typography>

                            <Box>
                                {selectedIds.has(question.id) ? (
                                    <Tooltip title="Remover do banco">
                                        <span>
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                color="secondary"
                                                startIcon={<DeleteIcon />}
                                                onClick={() => onRemove(question.id)}
                                            >
                                                Remover
                                            </Button>
                                        </span>
                                    </Tooltip>
                                ) : (
                                    <Tooltip title="Adicionar ao banco">
                                        <span>
                                            <Button
                                                size="small"
                                                variant="contained"
                                                color="primary"
                                                startIcon={<AddIcon />}
                                                onClick={() => onAdd(question)}
                                            >
                                                Adicionar
                                            </Button>
                                        </span>
                                    </Tooltip>
                                )}
                            </Box>
                        </Box>

                        <Box mb={2}>
                            <Typography variant="subtitle2">Enunciado</Typography>
                            <Typography>
                                <Box
                                    mt={1}
                                    p={1}
                                    style={{ borderRadius: 6, textAlign: "justify" }}
                                    dangerouslySetInnerHTML={{ __html: question.question }}
                                />
                            </Typography>
                        </Box>

                        <Box mb={2}>
                            <Typography variant="subtitle2">Alternativas</Typography>
                            <Box mt={1}>
                                {question.options.map((opt, idx) => {
                                    const letter = String.fromCharCode(65 + idx);
                                    return (
                                        <Box
                                            key={opt.id}
                                            mb={1}
                                            p={1}
                                            style={{
                                                borderRadius: 6,
                                                border: "1px solid " + (opt.isCorrect ? 'green' : '#e0e0e0'),
                                            }}
                                        >
                                            <Box
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="space-between"
                                            >
                                                <Typography variant="subtitle2" style={{color: opt.isCorrect ? 'green' : undefined,}}>
                                                    {letter} {opt.isCorrect ? "• Correta" : ""}
                                                </Typography>
                                            </Box>
                                            <Typography>
                                                <Box
                                                    mt={0.5}
                                                    style={{color: opt.isCorrect ? 'green' : undefined,}}
                                                    dangerouslySetInnerHTML={{ __html: opt.optionText }}
                                                />
                                            </Typography>
                                        </Box>
                                    );
                                })}
                            </Box>
                        </Box>

                        {question.comments ? (
                            <Box>
                                <Typography variant="subtitle2">Comentários</Typography>
                                <Typography variant="body2" color="textSecondary" align="justify">
                                    {question.comments}
                                </Typography>
                            </Box>
                        ) : null}
                    </>
                )}
            </Box>
        </Drawer>
    );
}
